import React from "react";
import CityList from "../cityList/cityList.component";
import { MapLeftOverlayStyled } from "./mapLeftOverlay.styles";

const MapLeftOverlay = ({ dataType = 1, show }) => {
  // useEffect(() => {
  //   // effect
  //   alert("hi");
  //   // return () => {
  //   //   // cleanup
  //   //   alert("bye");
  //   // };
  // }, [show]);
  return (
    <MapLeftOverlayStyled show={show}>
      <div className="left-overlay__content">
        {Number(dataType) === 1 ? <CityList show={show} /> : null}
      </div>
    </MapLeftOverlayStyled>
  );
};

export default MapLeftOverlay;
